import React from 'react'
import Main from '../../components/Agent/ToDos/Main'
import styles from '../../styles/agent/ToDos.module.css'


const ToDos = () => {


    return (
        <div className="container bodyContainer">
            <h1 className={`page-heading page-header ${styles.pageHeader}`}>To Dos</h1>
            <div className={`container ${styles.container}`}>
               <Main />
            </div>
        </div>
    )
}

export default ToDos
